<div
  class="grid-col-12 col-1-12 md-col-5-12 xl-col-6-12 no-gutters tier-benefits"
  [class.two-columns]="items?.length < 3"
>
  <div *ngFor="let item of items" class="mr-small-b">
    <div
      [class.white-text]="invertedColors"
      [class.nordic-blue-900-text]="!invertedColors"
      class="inline-block ms-medium-b"
    >
      <fcom-icon class="icon-xlarge" [name]="item.icon.name" [category]="item.icon.category"></fcom-icon>
    </div>

    <p class="font-heading-5">
      <span class="inline-block ms-medium-r ms-xsmall-b">
        {{ item.title || item.article.teaserTitle }}
      </span>
      <span
        *ngIf="item.changed"
        class="ps-xsmall-x ps-xxsmall-y medium-type alert-50-bg rounded-medium font-body-2 nordic-blue-900-text"
        >{{ 'LOYALTY.tierBenefits.tags.changed' | finLocalization }}</span
      >
    </p>

    <cms-unstyled-fragment
      *ngIf="item.article; else itemText"
      [showTitle]="false"
      [cmsContent$]="item.article | finToObservable"
    ></cms-unstyled-fragment>
    <ng-template #itemText
      ><div class="regular-type item-text-wrapper" [innerHTML]="item.text | finSafe: 'html'"></div
    ></ng-template>

    <a
      *ngFor="let link of item.article?.related"
      [finLink]="link.target.url"
      [external]="true"
      [openInNewTab]="link.target.openInNewTab"
      class="no-underline underline-hover block ps-large-t medium-type"
      [class.white-text]="invertedColors"
      [class.nordic-blue-900-text]="!invertedColors"
    >
      <span class="font-body-1 ps-xxsmall-r">{{ link.teaserTitle }}</span>
      <fcom-icon [name]="SvgLibraryIcon.ARROW_RIGHT"></fcom-icon>
    </a>
  </div>
</div>
